import { useTheme } from '../contexts/ThemeContext';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function BrandRail() {
  const { theme } = useTheme();
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    navigate('/');
  };

  // Calculate dynamic opacity and scale based on scroll
  const scrollProgress = Math.min(scrollY / 500, 1);
  const gradientOpacity = 0.05 + (scrollProgress * 0.15);

  return (
    <div 
      onClick={handleClick}
      className={`fixed lg:top-0 top-20 right-0 lg:h-screen h-[calc(100vh-5rem)] w-12 sm:w-14 md:w-16 lg:w-20 xl:w-24 z-30 flex flex-col items-center py-4 sm:py-6 lg:py-8 px-2 sm:px-3 lg:px-4 transition-all duration-300 cursor-pointer hover:scale-105 ${theme.railBg}`}
      role="complementary"
      aria-label="Seventh-day Adventist Church branding"
      style={{
        transform: `translateY(${scrollY * 0.1}px)`,
      }}
    >
      {/* Animated gradient overlays */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-white/5 via-transparent to-black/10 pointer-events-none transition-opacity duration-300"
        style={{ opacity: gradientOpacity }}
      ></div>
      <div 
        className="absolute inset-0 bg-gradient-to-br from-transparent via-white/3 to-transparent pointer-events-none transition-opacity duration-300"
        style={{ opacity: 1 - scrollProgress * 0.3 }}
      ></div>
      
      {/* Scroll-based shimmer effect */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-transparent via-white/10 to-transparent pointer-events-none transition-transform duration-700"
        style={{ 
          transform: `translateY(${-100 + (scrollProgress * 200)}%)`,
          opacity: scrollProgress > 0 ? 0.6 : 0
        }}
      ></div>
      
      {/* Logo */}
      <div 
        className="relative w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 xl:w-14 xl:h-14 mb-3 sm:mb-4 flex-shrink-0 transition-transform duration-300"
        style={{
          transform: `scale(${1 + scrollProgress * 0.1}) rotate(${scrollProgress * 5}deg)`
        }}
      >
        <img 
          src="https://static.readdy.ai/image/b26ccc3ae7fa45b3398224fbc482abd6/074d3102ffad2a455591f49f105c88ed.png"
          alt="Seventh-day Adventist Church logo"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Decorative divider - Hidden on mobile */}
      <div 
        className={`hidden sm:block w-6 lg:w-8 h-px mt-4 lg:mt-6 transition-all duration-300 ${theme.logoColor === 'light' ? 'bg-white/30' : 'bg-gray-800/30'}`}
        style={{
          width: `${24 + scrollProgress * 16}px`
        }}
      ></div>

      {/* Vertical text - Hidden on mobile, visible on tablet+ */}
      <div className="hidden md:flex relative flex-1 items-center justify-center">
        <div 
          className={`text-[10px] lg:text-xs font-semibold tracking-wider transition-all duration-300 ${theme.logoColor === 'light' ? 'text-white/60' : 'text-gray-800/60'}`}
          style={{ 
            writingMode: 'vertical-rl', 
            textOrientation: 'mixed',
            letterSpacing: '0.15em',
            opacity: 0.6 + scrollProgress * 0.4
          }}
        >
          Seventh-day Adventist Churches in Nigeria
        </div>
      </div>
    </div>
  );
}
